import { Action, createReducer, on } from "@ngrx/store";
import * as fromCoursesActions from "../actions/courses.action";
import { Course } from "cli-types";
import { clearCoursesStore } from "../actions/courses.action";

// creating an interface to say what type the initialState will be
// using entities (data objects) instead of arrays is better for perforance
export interface StudentCoursesListState {
    entities: Map<number, Course>;
    loaded: boolean;
    loading: boolean;
    selectedCourse: Course | null;
    courseID: number | null;
    languageID: number | null;
}

// set initial state as type StudentCoursesListState
export const initialState: StudentCoursesListState = {
    entities: new Map(),
    loaded: false,
    loading: false,
    selectedCourse: null,
    courseID: null,
    languageID: null,
};

const studentCoursesListReducer = createReducer(
    initialState,
    on(fromCoursesActions.loadStudentCourses, (state) => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(fromCoursesActions.loadStudentCoursesSuccess, (state, { payload }) => {
        const courses = payload;

        const entities = new Map<number, Course>();
        courses.forEach((course) => {
            entities.set(course.courseID, course);
        });

        // then re-bind the entity const with our returned state
        return {
            ...state,
            loading: false,
            loaded: true,
            entities,
        };
    }),
    on(fromCoursesActions.loadStudentCoursesFail, (state, { payload }) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    }),
    // 1st case is simply to load the teacher-classes
    on(fromCoursesActions.loadCourse, (state, { payload }) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    }),
    on(fromCoursesActions.setSelectedCourse, (state, { payload }) => {
        const course = payload;

        return {
            ...state,
            selectedCourse: course,
        };
    }),
    on(fromCoursesActions.loadSelectedCourseSuccess, (state, { course }) => {
        return {
            ...state,
            selectedCourse: course,
        };
    }),
    on(fromCoursesActions.loadCourseSuccess, (state, { payload }) => {
        const course = payload;

        const entities = new Map<number, Course>(state.entities.entries());
        entities.set(course.courseID, course);

        // then re-bind the entity const with our returned state
        return {
            ...state,
            courseID: course.courseID,
            languageID: course.languageID,
            loading: false,
            loaded: true,
            entities: entities,
        };
    }),
    on(fromCoursesActions.loadCourseFail, (state, { payload }) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    }),
    on(fromCoursesActions.clearCoursesStore, (state, {}) => {
        return {
            ...state,
            entities: new Map(),
            loaded: false,
            loading: false,
            selectedCourse: null,
            courseID: null,
            languageID: null,
        };
    })
);

export function reducer(
    state: StudentCoursesListState | undefined,
    action: Action
) {
    return studentCoursesListReducer(state, action);
}

// this is where we want to export some levels of state
export const getStudentCoursesEntities = (state: StudentCoursesListState) =>
    state.entities;
export const getStudentCoursesLoading = (state: StudentCoursesListState) =>
    state.loading;
export const getStudentCoursesLoaded = (state: StudentCoursesListState) =>
    state.loaded;
export const getSelectedCourse = (state: StudentCoursesListState) =>
    state.selectedCourse;
